import { BANNERS_ACTION_TYPES } from './actionTypes';
import { normalizeItems, updateIds } from "../utility";

const initialState = {
    byId: {},
    allIds: [],
    items: [],

    loading: {
        list: false,
    },
    error: {
        list: null,
    },
    lastUpdated: null,
};

export const bannersReducer = (state = initialState, action) => {
    switch (action.type) {
        case BANNERS_ACTION_TYPES.FETCH_LIST_REQUEST: {
            return {
                ...state,
                loading: { ...state.loading, list: true },
                error: { ...state.error, list: null }
            };
        }
        case BANNERS_ACTION_TYPES.FETCH_LIST_SUCCESS: {
            const { data } = action.payload;
            const { byId: newById, allIds: newIds } = normalizeItems(data);

            return {
                ...state,
                byId: { ...state.byId, ...newById },
                allIds: newIds,
                items: data,
                loading: { ...state.loading, list: false },
                lastUpdated: action.meta.timestamp,
            };
        }
        case BANNERS_ACTION_TYPES.FETCH_LIST_FAILURE: {
            return {
                ...state,
                loading: { ...state.loading, list: false },
                error: { ...state.error, list: action.payload.error },
            };
        }
        default:
            return state;
    }
}
